import { useState, type FormEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Inbox, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { ApiError } from '@/services/api';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(password);
      const from = (location.state as { from?: string } | null)?.from ?? '/dashboard';
      navigate(from, { replace: true });
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : 'login_failed';
      toast.error(msg === 'invalid_password' ? 'Invalid password' : msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-br from-gray-50 to-primary-50/30 px-4">
      <form onSubmit={onSubmit} className="card w-full max-w-sm p-6">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 grid h-10 w-10 place-items-center rounded-md bg-primary-600 text-white">
            <Inbox className="h-5 w-5" />
          </div>
          <h1 className="text-lg font-semibold">JobApplier Admin</h1>
          <p className="text-xs text-gray-500">Sign in to manage applications</p>
        </div>
        <label className="mb-1 block text-xs font-medium text-gray-700">Password</label>
        <input
          type="password"
          className="input"
          autoFocus
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          type="submit"
          disabled={!password || submitting}
          className="btn-primary mt-4 w-full"
        >
          {submitting && <Loader2 className="h-4 w-4 animate-spin" />}
          Sign in
        </button>
      </form>
    </div>
  );
}
